import script from "./TenantsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantsPage.vue?vue&type=script&setup=true&lang=js"

import "./TenantsPage.vue?vue&type=style&index=0&id=13718866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13718866"]])

export default __exports__